import React from 'react';

import { FeatureGuard } from '@components/Guards';
import NotFound from '@components/NotFound';

import OrgSettingLayout from '@views/Organization/OrgSettingManagementLayout';
import OrgBrandSettings from '@views/Organization/Setting/Brand';

export default function ManageOrgBrandSettingsPage(
  props: PagePropsWithBreadcrumbs
) {
  return (
    <OrgSettingLayout pageProps={props}>
      {({ account, accountSettings, loading }) => (
        <FeatureGuard feature="AccountUpdateAccountSetting">
          {accountSettings?.getAccountSetting?.license?.enabled_branding ? (
            <OrgBrandSettings
              account={account}
              accountSettings={accountSettings}
              loading={loading}
            />
          ) : (
            <NotFound />
          )}
        </FeatureGuard>
      )}
    </OrgSettingLayout>
  );
}
